/**
 * Pure logic for the ImageGrid block's "List" settings tab.
 * Extracted from ImageGridSettings (behaviour-preserving) so the count-badge
 * label and the remove-image filter are unit-testable without CraftJS/Redux.
 * Coverage-map cell: builder:6.27 (List — reorder/remove images; count badge;
 * empty). Reorder is native CraftJS drag-and-drop and stays browser-only
 * (same class as builder:6.18/4.38); count-badge and remove are pure and
 * covered here.
 */

/**
 * Tab label for the List sub-tab: "List " (trailing space, no badge) when
 * empty, "List (N)" once populated — the measured count badge (qa-validator
 * fleet/w3-bld-edit SESSION 7, "List" at 0 images -> "List (1)" after
 * upload). Matches the original inline template literal byte-for-byte
 * (including the trailing space in the empty case) so this is a pure
 * extraction, not a behaviour change.
 * @param {number} imagesLength
 */
export function imageGridListLabel(imagesLength) {
  return `List ${imagesLength ? "(" + imagesLength + ")" : ""}`;
}

/**
 * Removes one image by id from the ImageGrid's images array. Mirrors the
 * ImageGridSettings `handleChange("removeImage", id)` branch exactly (a
 * plain filter) so it can be called from inside the CraftJS `setProp` immer
 * draft without changing behaviour.
 * @param {Array<{id:*}>} images
 * @param {*} id
 */
export function removeImageById(images, id) {
  return (images || []).filter((image) => image.id !== id);
}

/**
 * Gordon 12:25 PT spec part 2: removing the last image from a block's list
 * (going from >0 images to 0) means the block's sole content is gone, so the
 * whole block must be removed rather than left rendering its empty-state
 * skeleton. Shared by ImageGrid and Carousel, whose settings panes both
 * funnel every List-driven removal through `newImages`/`removeImage`.
 * @param {Array} previousImages
 * @param {Array} nextImages
 */
export function isLastImageRemoval(previousImages, nextImages) {
  return (previousImages?.length || 0) > 0 && (nextImages?.length || 0) === 0;
}
